/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Students_Action_WhatsappInputs */

const en_students_action_whatsapp = /** @type {(inputs: Students_Action_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp`)
};

const he_students_action_whatsapp = /** @type {(inputs: Students_Action_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`וואטסאפ`)
};

/**
* | output |
* | --- |
* | "WhatsApp" |
*
* @param {Students_Action_WhatsappInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const students_action_whatsapp = /** @type {((inputs?: Students_Action_WhatsappInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Students_Action_WhatsappInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_students_action_whatsapp(inputs)
	return he_students_action_whatsapp(inputs)
});